// A minimal pub/sub. `Args` is the tuple of arguments passed to `emit` and
// received by each listener — defaults to none, so `new MiniEvent()` yields
// `() => void` listeners. For a payload, e.g. `new MiniEvent<[UploadState]>()`.
export default class MiniEvent<Args extends unknown[] = []> {
  listeners = new Set<(...args: Args) => void>();

  addListener = (cb: (...args: Args) => void) => {
    this.listeners.add(cb);
    return () => this.listeners.delete(cb);
  };

  emit = (...args: Args) => {
    this.listeners.forEach((l) => l(...args));
  };

  isSomeoneListening = () => this.listeners.size > 0;
}
